/**
 * Centralized form element tokens.
 * All form controls (Input, Select, NumberStepper, etc.) should reference these
 * so that height, border, radius, and focus styles stay in sync.
 */

/* ── Size presets ─────────────────────────────────────────────────────────────── */

export const FORM_SIZES = {
  xs:      { height: 'h-6',  minHeight: 'min-h-6',  text: 'text-xs',    px: 'px-1.5' },
  sm:      { height: 'h-7',  minHeight: 'min-h-7',  text: 'text-xs',    px: 'px-2' },
  default: { height: 'h-8',  minHeight: 'min-h-8',  text: 'text-sm',    px: 'px-3' },
  md:      { height: 'h-9',  minHeight: 'min-h-9',  text: 'text-sm',    px: 'px-3' },
  lg:      { height: 'h-10', minHeight: 'min-h-10', text: 'text-base',  px: 'px-4' },
} as const;

export type FormSize = keyof typeof FORM_SIZES;

/* ── Shared visual tokens ────────────────────────────────────────────────────── */

/** Border color for all form controls */
export const FORM_BORDER = 'border-input';

/** Border radius for all form controls */
export const FORM_RADIUS = 'rounded-md';

/** Shadow for all form controls */
export const FORM_SHADOW = 'shadow-sm';

/** Focus ring shared by all form controls */
export const FORM_FOCUS = 'focus-visible:ring-1 focus-visible:ring-ring';

/** Focus-within ring for composite controls (NumberStepper) */
export const FORM_FOCUS_WITHIN = 'focus-within:ring-1 focus-within:ring-ring focus-within:border-ring';

/** Disabled state */
export const FORM_DISABLED = 'disabled:cursor-not-allowed disabled:opacity-50';

/** Placeholder color */
export const FORM_PLACEHOLDER = 'placeholder:text-gray-400';
